var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarPlaceholderPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.491,
    cy: 51.218,
    r: 51.218,
    fill: "#DBD6EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.76 89.631c-17.532 0-31.744-8.846-31.744-19.759 0-10.912 14.212-19.758 31.743-19.758 17.533 0 31.745 8.846 31.745 19.758 0 10.912-14.212 19.759-31.745 19.759Zm0-42.123v-.001a17.086 17.086 0 0 1-12.129-5.106 17.44 17.44 0 0 1-5.006-12.272 17.443 17.443 0 0 1 5.045-12.257 17.087 17.087 0 0 1 12.144-5.067 17.091 17.091 0 0 1 12.136 5.087 17.443 17.443 0 0 1 5.025 12.265 17.46 17.46 0 0 1-5.05 12.277 17.107 17.107 0 0 1-12.166 5.073Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholderPurple);
export default __webpack_public_path__ + "static/media/avatar_placeholder_purple.49b30408f753aaba48426c786b958428.svg";
export { ForwardRef as ReactComponent };